import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import UserEditPage from '../components/UserEditPage'
import {
  actionCreators,
  IUserEditState,
  selectCanSave,
  selectUser,
} from '../modules/userEdit'

type IComponentState = IUserEditState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      user: selectUser(),
    }),
    actionCreators,
  )(UserEditPage),
)
